import { IModalStore } from './index'

export default {
  modals: [],
  tooltips: [],
  hideModal: false,
} as IModalStore
